<template>
    <v-select transition="" v-model="selectedIcd10Code"
              @search="getIcdList"
              :searchable="true"
              style="margin-bottom: 1.5%;"
              :id="index+'_icd_'+appointmentId"
              :reduce="s => s.id" label="name"
              :options="icdList">
    </v-select>
</template>


<script>
    import saglinetService from '@/services/sagliknet'

    export default {
        props: ["index", "appointmentId", "selected"],
        data() {
            return {
                selectedIcd10Code: '',
                icdList: []
            };
        },
        methods: {
            getIcdList(search) {
                if (search.length > 2) {
                    saglinetService.getIcdList(search)
                        .then(response => {
                            this.icdList = response;
                        });
                }
            }
        },
        watch: {
            selectedIcd10Code: function (val) {
                if (val && this.selected == true) {
                    let data = this.$parent.$parent.selectedData.find(s => s.appointmentId == this.appointmentId);

                    if (data) {
                        let index = this.$parent.$parent.selectedData.indexOf(data);

                        if (this.$parent.$parent.selectedData[index].icdCodes[this.index] == null)
                            this.$parent.$parent.selectedData[index].icdCodes.push({
                                icdCode: val,
                                icdText: this.icdList.find(s => s.id == val).name
                            });
                        else {
                            this.$parent.$parent.selectedData[index].icdCodes[this.index].icdCode = val
                            this.$parent.$parent.selectedData[index].icdCodes[this.index].icdText = this.icdList.find(s => s.id == val).name
                        }
                    }

                }
            },
            selected: function (val) {
                if (this.selectedIcd10Code && val == true) {

                    let data = this.$parent.$parent.selectedData.find(s => s.appointmentId == this.appointmentId);

                    if (data) {
                        let index = this.$parent.$parent.selectedData.indexOf(data);

                        if (this.$parent.$parent.selectedData[index].icdCodes[this.index] == null)
                            this.$parent.$parent.selectedData[index].icdCodes.push({
                                icdCode: this.selectedIcd10Code,
                                icdText: this.icdList.find(s => s.id == this.selectedIcd10Code).name
                            });
                    }

                }
            }
        },
        mounted: function () {
            if (this.index == 0) {
                this.selectedIcd10Code = 'Z00.0';
              this.icdList.push({ id: 'Z00.0', name: this.$store.getters['Auth/currentStaff'].language == 'tr' ? 'Z00.0 - Genel tıbbi muayene' : 'Z00.0 - Encounter for general adult medical examination' })
            }
        }
    };
</script>
